<div class="container mb-3">
  <div class="row header  bg-white">
    <div class="col text-center cursor " [ngClass]="{'border-bottom-blue': myvouchers}"
         (click)="onTypeClick('MY_VOUCHERS')">
      <label class="m-3 font-weight-bold card-title">My Voucher</label>
    </div>
    <div class="col text-center cursor" [ngClass]="{'border-bottom-blue': browsevouchers}"
         (click)="onTypeClick('BROWSE')">
      <label class="m-3 font-weight-bold card-title">Browse</label>
    </div>

  </div>
</div>
<div class="content-orders bg-white">
  <div *ngIf="myvouchers" class="container">
    <div class="row form-group">
      <div class="col border-bottom">
        <label for="" class="font-weight-bold font-size-16">Current</label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col">
        <div class="row form-group" *ngFor="let voucher of currentVouchers">
          <div class="col">
            <div class="row">
              <div class="col-6">
                <div>
                  <span class="font-weight-bold font-size-16">
                    {{voucher.VoucherName}}
                  </span>
                </div>
                <div>
                  <span class="text-muted">
                    Expires : {{voucher.Expires}}
                  </span>
                </div>
                <div>
                  <span class="text-muted">
                    Minimun order : {{voucher.MinOrderAmount}} {{currency}}
                  </span>
                </div>
              </div>
              <div class="col-6 text-right">
                <span class="font-weight-bold font-size-16">
                  {{voucher.VoucherAmount}} {{currency}}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div>
                  <span class="text-muted">
                    {{voucher.VoucherDescription}}
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="row form-group">
      <div class="col border-bottom">
        <label for="" class="font-weight-bold font-size-16">Past</label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col">
        <div class="row form-group" *ngFor="let voucher of pastVouchers">
          <div class="col">
            <div class="row">
              <div class="col-6">
                <div>
                  <span class="font-weight-bold font-size-16">
                    {{voucher.VoucherName}}
                  </span>
                </div>
                <div>
                  <span class="text-muted">
                    Expires : {{voucher.Expires}}
                  </span>
                </div>
                <div>
                  <span class="text-muted">
                    Minimun order : {{voucher.MinOrderAmount}} {{currency}}
                  </span>
                </div>
              </div>
              <div class="col-6 text-right">
                <span class="font-weight-bold font-size-16">
                  {{voucher.VoucherAmount}} {{currency}}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div>
                  <span class="text-muted">
                    {{voucher.VoucherDescription}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="">You can apply your vouchers at the checkout, <span class="text-primary cursor" (click)="onOrderNowClick()" *ngIf="!qrCodeScanned">Order now</span> </label>
      </div>
    </div>
  </div>
  <div *ngIf="browsevouchers" class="container">
    <div class="row form-group">
      <div class="col">
        <div class="row form-group" *ngIf="newVouchers.length === 0">
          <div class="col text-center mt-3">
            <label for="">No vouchers found</label>
          </div>
        </div>
        <div class="row form-group" *ngFor="let voucher of newVouchers;let i= index">
          <div class="col">
            <div class="row">
              <div class="col-6">
                <div>
                  <span class="font-weight-bold font-size-16">
                    {{voucher.VoucherName}}
                  </span>
                </div>
                <div>
                  <span class="text-muted">
                    Minimun order : {{voucher.MinOrderAmount}} {{currency}}
                  </span>
                </div>
              </div>
              <div class="col-6 text-right">
                <div>
                  <span class="font-weight-bold font-size-16">
                    {{voucher.VoucherAmount}} {{currency}}
                  </span>
                </div>
                <div>
                  <button class="btn btn-primary btn-rounded btn-sm" (click)="onClaimClick(i,voucher)">Claim</button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div>
                  <span class="text-muted">
                    {{voucher.VoucherDescription}}
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div>
                  <span class="text-muted text-warning">
                    {{voucher.message}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-ecom-footer class="footer"></app-ecom-footer>
<app-loading-component></app-loading-component>
